import * as angular from 'angular';

/**
 * Segmented radio input + custom.
 *
 * This component builds a segmented radio button list that has a `custom`
 * value option. If `custom` is selected, it displays the additional form
 * element passed between the tags. This combo input assumes two different
 * items in the model for the key (ie - `custom`) and the custom value, bound
 * to each form input separately.
 */
class RadioComboInputController implements angular.IController {
  private ngModelCtrl: angular.INgModelController;

  // bindings
  inputId: string;
  inputLabel: string;
  radioOptions: { id: string | number; label: string; class?: string }[];

  // Local state
  radiosName: string;

  constructor() {}

  $onInit() {
    this.radiosName = `radio-combo-${this.inputId}`;
  }

  /**
   * Set model.
   *
   * This will trigger `on-change` on the component wrapper, if present.
   */
  setNgModel(value: string): void {
    this.ngModelCtrl.$setViewValue(value);
  }

  /**
   * Handle the radio changing events and set model.
   */
  radiosChanged(value: string): void {
    this.setNgModel(value);
  }
}

export const RadioComboInputComponent: angular.IComponentOptions = {
  bindings: {
    inputId: '@',
    inputLabel: '@',
    radioOptions: '<',
    ngModel: '<',
  },
  controller: RadioComboInputController,
  controllerAs: 'ctrl',
  require: {
    ngModelCtrl: 'ngModel',
  },
  transclude: true,
  template: `
  <div class="radio-combo-field">
    <label ng-if="ctrl.inputLabel" class="field-label">{{ ctrl.inputLabel }}</label>
    <div class="radio-buttons radio-segmented">
      <label ng-repeat="radioOption in ctrl.radioOptions" class="radio-label">
        <input type="radio" ng-model="ctrl.ngModel" ng-value="radioOption.id" ng-change="ctrl.radiosChanged(radioOption.id)" name="{{ ctrl.radiosName }}">
        <span class="radio-option-title">{{ radioOption.label }}</span>
      </label>

      <label class="radio-label radio-item-custom">
        <input type="radio" ng-model="ctrl.ngModel" value="custom" ng-change="ctrl.radiosChanged('custom')" name="{{ ctrl.radiosName }}">
        <span class="radio-option-title">...</span>
      </label>
    </div>
    <div ng-if="ctrl.ngModel === 'custom'" class="custom-value-input">
      <ng-transclude></ng-transclude>
    </div>
  </div>
  `,
};
